import { styled } from "styled-components";
import { mobileBreakpoint } from "../../Configs/Config";
import { AnalyticsContainerIntro } from "../../Pages/DashboardStyle";

export const InnerContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 80%;
    height: 25%;
    margin-top: 0;
    animation: ${AnalyticsContainerIntro}
        ${(props) => props.theme.animationTime.medium}s;
    box-shadow: 0px 0px 13px 7px rgba(0, 0, 0, 0.74);
    border: 1px solid #ffa600;
    @media screen and (max-width: ${mobileBreakpoint}px) {
        flex-direction: column;
        border-radius: 0;
        height: 100%;
        width: 100%;
        box-shadow: none;
        border: none;
        align-items: center;
        justify-content: center;
        padding-bottom: 30%;
    }

`;
